import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function BookingTypePage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-[calc(100vh-11rem)] flex items-start justify-center text-white">
      <div className="w-full max-w-[340px] px-4 pt-1 pb-8 md:max-w-[420px]">
        <button
          type="button"
          onClick={() => navigate(-1)}
          className="mb-4 inline-flex items-center gap-2 text-xs font-bold text-slate-300 hover:text-white transition"
        >
          <ArrowLeft size={14} /> Back
        </button>

        <h1 className="text-2xl md:text-3xl font-bold text-white text-center mb-7">Event Booking</h1>

        <div className="text-center mb-6">
          <p className="text-sm text-slate-200 leading-snug">Which type of event are you planning?</p>
          <p className="text-sm text-slate-300">Select below to begin.</p>
        </div>

        <div className="space-y-5">
          <Link
            to="/book/concert"
            className="relative block h-32 md:h-36 rounded-[20px] overflow-hidden border border-[#5b0000]"
            style={{
              backgroundImage:
                'linear-gradient(0deg, rgba(108,0,0,0.62), rgba(108,0,0,0.62)), radial-gradient(circle at 20% 80%, rgba(255,255,255,0.18), transparent 35%), linear-gradient(135deg, #240000 0%, #650000 100%)',
            }}
          >
            <div className="absolute inset-0 grid place-items-center px-4">
              <h2 className="text-white text-3xl md:text-4xl font-extrabold text-center leading-tight">Concert{`\n`}Event</h2>
            </div>
          </Link>

          <Link
            to="/book/corporate"
            className="relative block h-32 md:h-36 rounded-[20px] overflow-hidden border border-[#5b0000]"
            style={{
              backgroundImage:
                'linear-gradient(0deg, rgba(108,0,0,0.62), rgba(108,0,0,0.62)), radial-gradient(circle at 80% 20%, rgba(255,255,255,0.18), transparent 35%), linear-gradient(135deg, #2e0000 0%, #6f0000 100%)',
            }}
          >
            <div className="absolute inset-0 grid place-items-center px-4">
              <h2 className="text-white text-3xl md:text-4xl font-extrabold text-center leading-tight">Corporate{`\n`}Event</h2>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
}
